import { createReducer, on } from '@ngrx/store';

import {
  getServiceConfig,
  getServiceConfigError,
  getServiceConfigSuccess,
  setServiceSectionExpanded,
} from './service-configuration.actions';

export const serviceConfigurationFeatureKey = 'serviceConfiguration';

export interface State {
  expandedSections: {
    Statuses: boolean;
    Resident: boolean;
    Triggers: boolean;
  };
}

export const initialState: State = {
  expandedSections: {
    Statuses: true,
    Resident: false,
    Triggers: false,
  },
};

export const reducer = createReducer(
  initialState,
  on(getServiceConfig, (state, action) => ({ ...state, serviceConfigLoading: false })),
  on(getServiceConfigSuccess, (state, action) => ({
    ...state,
    serviceConfigLoading: false,
    serviceConfig: action.serviceConfig,
  })),
  on(getServiceConfigError, (state, action) => ({
    ...state,
    serviceConfigLoading: false,
    serviceConfig: null,
  })),
  on(setServiceSectionExpanded, (state, action) => ({
    ...state,
    expandedSections: {
      ...state.expandedSections,
      [action.section]: action.state,
    },
  }))
);
